<template>
    <div class=".container">
        <!-- 素早さ自動調整機能 -->
        <div class="card mb-2" style="width: auto;">
            <div class="card-header main_card">
                素早さ自動調整機能
            </div>
            <div class="card-body">
                <!-- 自動調整設定フォーム -->
                <div class="card mb-3" style="width: auto;">
                    <div class="card-header control_card">
                        自動調整設定 ・ 実行
                    </div>
                    <div class="card-body">
                        <div class="row row-cols-sm-2 row-cols-1">
                            <div class="col-sm-6 col-12">
                                <table class="table table-striped table-bordered">
                                    <thead>
                                        <tr class="text-center">
                                            <th>個体値</th>
                                            <th>性格</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="form-check">
                                                    <input type="radio" class="form-check-input" id="ind" v-model="target_ind_change" :value=true>
                                                    <label for="ind" class="form-check-label text-danger">変更可能<br> ( 31 or 0 )</label>
                                                </div>
                                                <div class="form-check">
                                                    <input type="radio" class="form-check-input" id="ind" v-model="target_ind_change" :value=false>
                                                    <label for="ind" class="form-check-label text-primary">固定</label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-check">
                                                    <input type="radio" class="form-check-input" id="cha" v-model="target_cha_change" :value=true>
                                                    <label for="cha" class="form-check-label text-danger">変更可能<br> ( 上昇 or 下降 )</label>
                                                </div>
                                                <div class="form-check">
                                                    <input type="radio" class="form-check-input" id="cha" v-model="target_cha_change" :value=false>
                                                    <label for="cha" class="form-check-label text-primary">固定</label>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-sm-6 col-12">
                                <table class="table table-striped table-bordered">
                                    <thead>
                                        <tr class="text-center">
                                            <th colspan="2"><span class="text-success">目標ライン</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="input-group">
                                                    <input type="number" class="form-control" min="1" max="500" v-model="target_line_num" @input="checkValueRange('target_line_num','line')">
                                                    <span class="input-group-text">以上</span>
                                                    <select class="form-select" id="line_select" v-model="target_line_handler">
                                                        <option v-for="selected_line in target_line_handler_list" :value="selected_line" :key="selected_line" :selected="selected_line === target_line_handler_list[0]">{{ selected_line }}</option>
                                                    </select>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <div v-if="target_line_handler === '遅く'" class="form-check form-switch">
                                        <input type="checkbox" class="form-check-input" id="waste_switch" v-model="waste_eff">
                                        <label for="waste_switch" class="form-check-label">仮想敵の素早さに極力近づける</label>
                                    </div>
                                </table>
                            </div>
                        </div>
                        <button v-on:click="calculateAutoSpeed()" class="btn btn-outline-success w-100">自動調整 実行</button>
                    </div>
                </div>
                <!-- 仮想敵設定フォーム -->
                <div class="card mb-3" style="width: auto;">
                    <div class="card-header enemy_card">
                        仮想敵設定
                    </div>
                    <div class="card-body">
                        <!-- ポケモン名入力フォーム -->
                        <div class="row mb-2">
                            <div class="col-md-2 col-sm-3 col-4">
                                <img v-if="checkEnemyPokemonImageId" :src="getEnemyPokemonImage()" alt="target_image" class="img-thumbnail img-fluid">
                                <img v-else src="../assets/not_applicable.png" alt="target_image" class="img-thumbnail img-fluid">
                            </div>
                            <form class="col-md-10 col-sm-9 col-8">
                                <div class="form-floating mb-1">
                                    <input type="text" class="form-control" id="pokemonInput" list="pokemons" v-model="enemy_name" @input="hiragana2Katakana">
                                    <label for="pokemonInput">ポケモン名 入力欄</label>
                                    <datalist id="pokemons">
                                        <option v-for="pokemon in getPokemonList" :value="pokemon" :key="pokemon"></option>
                                    </datalist>
                                </div>
                                <button v-if="searchRequestFlag === 0" v-on:click="searchEnemyRequest()" class="btn btn-sm btn-outline-primary w-100" disabled>反映</button>
                                <button v-else-if="searchRequestFlag === 2" v-on:click="searchEnemyRequest()" class="btn btn-sm btn-outline-primary w-100" disabled>反映中</button>
                                <button v-else v-on:click="searchEnemyRequest()" class="btn btn-sm btn-outline-primary w-100">反映</button>
                                <div class="p-1">
                                    <a v-if="checkEnemyPokemonId" class="link" :href="getPokeTetsuLink()" target="_blank" rel="noopener noreferrer">詳細情報(ポケ徹リンク)</a>
                                    <span v-else class="text-muted text-decoration-underline">詳細情報(ポケ徹リンク)</span>
                                </div>
                            </form>
                        </div>
                        <div class="text-center">
                            <div class="row row-cols-sm-2 row-cols-1">
                                <div class="col-sm-9 col-12">
                                    <!-- 実数値&3値の表示及び編集フォーム -->
                                    <table class="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>実数値</th>
                                                <th>種族値</th>
                                                <th>個体値</th>
                                                <th>努力値</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><span :class="getCharacterColor()">素早さ</span></td>
                                                <td><span :class="getCharacterColor()">{{ calculateEnemySpeed() }}</span></td>
                                                <td>{{ this.enemy_s_base }}</td>
                                                <td><input type="number" class="form-control" min="0" max="31" v-model="enemy_s_ind" @input="checkValueRange('enemy_s_ind','ind')"></td>
                                                <td><input type="number" class="form-control" min="0" max="252" step="4" v-model="enemy_s_eff" @input="checkValueRange('enemy_s_eff','eff')"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- 素早さテンプレボタン -->
                                <div class="col-sm-3 order-sm-0 order-2 align-self-center mb-2">
                                    <div class="row row-cols-2">
                                        <div class="col-6" style="padding-right: 2%;">
                                            <button v-on:click="setTemplateSpeed('最速')" class="btn btn-sm btn-outline-primary w-100 mb-2">最速</button>
                                        </div>
                                        <div class="col-6" style="padding-left: 2%;">
                                            <button v-on:click="setTemplateSpeed('準速')" class="btn btn-sm btn-outline-primary w-100 mb-2">準速</button>
                                        </div>
                                        <div class="col-6" style="padding-right: 2%;">
                                            <button v-on:click="setTemplateSpeed('無振り')" class="btn btn-sm btn-outline-primary w-100 mb-2">無振り</button>
                                        </div>
                                        <div class="col-6" style="padding-left: 2%;">
                                            <button v-on:click="setTemplateSpeed('最遅')" class="btn btn-sm btn-outline-primary w-100 mb-2">最遅</button>
                                        </div>
                                    </div>
                                </div>
                                <!-- レベル&性格&ランク補正登録フォーム -->
                                <div class="col-sm-6 order-1">
                                    <div class="row row-cols-sm-3 row-cols-2">
                                        <div class="col-sm-3 col-6" style="padding-right: 1%;">
                                            <table class="table table-striped table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>レベル</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><input type="number" class="form-control" min="1" max="100" v-model="enemy_level" @input="checkValueRange('enemy_level','level')"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-sm-3 col-6" style="padding-left: 1%;">
                                            <table class="table table-striped table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>特性</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><input type="number" class="form-control" min="0.5" max="2" step="0.5" v-model="enemy_skill" @input="checkValueRange('enemy_skill','skill')"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-sm-6 order-1 col-12">
                                            <table class="table table-striped table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>性格</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <select class="form-select" id="cha_select" v-model="enemy_s_cha">
                                                                <option v-for="enemy_ability in enemy_ability_list" :value="enemy_ability" :key="enemy_ability" :selected="enemy_ability === enemy_ability_list[1]">{{ enemy_ability }}</option>
                                                            </select>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6 order-3">
                                    <div class="row row-cols-3">
                                        <div class="col-4" style="padding-right: 1%;">
                                            <table class="table table-striped table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>ランク</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><input type="number" class="form-control" min="-6" max="6" v-model="enemy_rank" @input="checkValueRange('enemy_rank','rank')"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-4" style="padding-right: 1%; padding-left: 1%;">
                                            <table class="table table-striped table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>持ち物</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><input type="number" class="form-control" min="0.5" max="2" step="0.5" v-model="enemy_item" @input="checkValueRange('enemy_item','item')"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-4" style="padding-left: 1%;">
                                            <table class="table table-striped table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>麻痺</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><input type="number" class="form-control" min="0.5" max="1" step="0.5" v-model="enemy_paralysis" @input="checkValueRange('enemy_paralysis','paralysis')"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="reset_cor_button mb-3">
                                <button v-on:click="resetCorrection()" class="btn btn-sm btn-outline-danger w-100">各種補正リセット</button>
                            </div>
                            <div class="border mb-3 border-opacity-50">
                                仮想敵 素早さ実数値 (各種補正後)
                            </div>
                            <div :class="getCharacterColor()" style="font-size: 2.5rem;">
                                <h1>{{ calculateEnemyFinalSpeed() }}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AutoSpeedControl",
    data() {
        return {
            enemy_name: "",
            post_send: false,
            enemy_id: null,
            enemy_image_id: null,
            enemy_level: 50,
            enemy_s_base: 10,
            enemy_s_ind: 31,
            enemy_s_eff: 0,
            enemy_s_cha: "補正なし",
            enemy_ability_list: ["上昇補正", "補正なし", "下降補正"],
            enemy_rank: 0,
            enemy_skill: 1,
            enemy_item: 1,
            enemy_paralysis: 1,
            target_ind_change: false,
            target_cha_change: true,
            waste_eff: false,
            target_line_num: 1,
            target_line_handler: "速く",
            target_line_handler_list: ["速く", "遅く"],
        };
    },
    methods: {
        /**
         * 努力値自動計算処理(本体)
         */
        calculateAutoSpeed() {
            let target_line = this.calculateEnemyFinalSpeed();
            /* ユーザの指定した調整設定の反映 */
            switch (this.target_line_handler) {
                case "速く":
                    target_line += this.target_line_num;
                    if (this.target_ind_change)
                        this.$store.dispatch("autoSpeed/saveAutoSInd", 31); //個体値31
                    if (this.target_cha_change) { //性格補正
                        this.$store.dispatch("autoSpeed/saveAutoUpCharacter", "素早さ"); //素早さ上昇
                        this.$store.dispatch("autoSpeed/saveAutoDownCharacter", "---"); //下降はリセット
                    }
                    break;
                case "遅く":
                    target_line -= this.target_line_num;
                    if (this.target_ind_change)
                        this.$store.dispatch("autoSpeed/saveAutoSInd", 0); //個体値0
                    if (this.target_cha_change) { //性格補正
                        this.$store.dispatch("autoSpeed/saveAutoUpCharacter", "---"); //上昇はリセット
                        this.$store.dispatch("autoSpeed/saveAutoDownCharacter", "素早さ"); //素早さ下降
                    }
                    break;
                default:
                    this.$store.dispatch("alertModal/saveTitle","Technical Error");
                    this.$store.dispatch("alertModal/saveMessage","以下の内容と直前の作業内容を管理人に報告してください。\ncalculateAutoSpeed() Bug:handlerに正しい値を設定してください。");
                    this.$store.dispatch("alertModal/changeFlagState");
            }
            /* 各種補正の逆算 */
            target_line = Math.ceil(target_line / this.returnRankcorrection(this.$store.getters["autoSpeed/getAutoRank"])); //ランク補正
            target_line = Math.ceil(target_line / this.$store.getters["autoSpeed/getAutoSkill"]); //特性補正
            target_line = Math.ceil(target_line / this.$store.getters["autoSpeed/getAutoItem"]); //道具補正
            target_line = Math.ceil(target_line / this.$store.getters["autoSpeed/getAutoParalysis"]); //麻痺補正
            if (this.$store.getters["autoSpeed/getAutoUpCharacter"] === "素早さ") { //性格上昇補正
                target_line = Math.ceil(target_line / 1.1);
            } else if (this.$store.getters["autoSpeed/getAutoDownCharacter"] === "素早さ") { //性格下降補正
                target_line = Math.ceil(target_line / 0.9);
            }
            /* 努力値算出 */
            let eff_result = 4 * ((100 * target_line - 500) / this.$store.getters["autoSpeed/getAutoLevel"] - (2 * this.$store.getters["targetPokemon/getS"] + this.$store.getters["autoSpeed/getAutoSInd"]));
            if (eff_result > 252) { //必要な努力値が252以上
                this.$store.dispatch("alertModal/saveTitle","調整結果");
                this.$store.dispatch("alertModal/saveMessage","調整不可：設定された条件では必要な努力値が252を超えてしまいます。");
                this.$store.dispatch("alertModal/changeFlagState");
            } else if (eff_result < 0 && this.target_line_handler === "速く") { //上回るのに必要な努力値が0未満
                this.$store.dispatch("autoSpeed/saveAutoSEff", 0); //結果として0を登録
                this.$store.dispatch("alertModal/saveTitle","調整結果");
                this.$store.dispatch("alertModal/saveMessage","以下のように調整されました。\n努力値：" + this.$store.getters["autoSpeed/getAutoSEff"] + "\n個体値：" + this.$store.getters["autoSpeed/getAutoSInd"] + "\n性格(上昇補正)：" + this.$store.getters["autoSpeed/getAutoUpCharacter"] + "\n性格(下降補正)：" + this.$store.getters["autoSpeed/getAutoDownCharacter"]);
                this.$store.dispatch("alertModal/changeFlagState");
            } else if (eff_result < 0 && this.target_line_handler === "遅く") { //下回るのに必要な努力値が0未満
                this.$store.dispatch("alertModal/saveTitle","調整結果");
                this.$store.dispatch("alertModal/saveMessage","調整不可：設定された条件では仮想敵の速度を下回ることができません。");
                this.$store.dispatch("alertModal/changeFlagState");
            } else if (eff_result > 0 && this.waste_eff === false && this.target_line_handler === "遅く") { //仮想敵の実数値に極力近づけるための努力値振りを避けたい場合
                this.$store.dispatch("autoSpeed/saveAutoSEff", 0); //結果として0を登録
                this.$store.dispatch("alertModal/saveTitle","調整結果");
                this.$store.dispatch("alertModal/saveMessage","以下のように調整されました。\n努力値：" + this.$store.getters["autoSpeed/getAutoSEff"] + "\n個体値：" + this.$store.getters["autoSpeed/getAutoSInd"] + "\n性格(上昇補正)：" + this.$store.getters["autoSpeed/getAutoUpCharacter"] + "\n性格(下降補正)：" + this.$store.getters["autoSpeed/getAutoDownCharacter"]);
                this.$store.dispatch("alertModal/changeFlagState");
            } else {
                this.$store.dispatch("autoSpeed/saveAutoSEff", eff_result); //結果登録
                this.$store.dispatch("alertModal/saveTitle","調整結果");
                this.$store.dispatch("alertModal/saveMessage","以下のように調整されました。\n努力値：" + this.$store.getters["autoSpeed/getAutoSEff"] + "\n個体値：" + this.$store.getters["autoSpeed/getAutoSInd"] + "\n性格(上昇補正)：" + this.$store.getters["autoSpeed/getAutoUpCharacter"] + "\n性格(下降補正)：" + this.$store.getters["autoSpeed/getAutoDownCharacter"]);
                this.$store.dispatch("alertModal/changeFlagState");
            }
        },
        /**
         * 入力された仮想敵ポケモン名を検索し、検索結果を反映
         */
        searchEnemyRequest() {
            /* Google App Scriptで構築したバックエンドにPOST */
            let P_URL = new URL("https://script.google.com/macros/s/AKfycbylhPI1yISh_8XR6OJp5BPD5EdE70BdvlflWaQHRJKguspBl5EPPK9yZy3d26GTnJcU/exec");
            const formData = new FormData();
            formData.append("name", this.enemy_name); //入力された仮想敵ポケモン名
            formData.append("handler", "SEARCH"); //バックエンドへの要求内容(入力されたポケモンの検索)
            this.post_send = true; //POSTリクエスト中のフラグを立てる
            fetch(P_URL, {
                method: "POST",
                body: formData
            }).then(res => {
                console.log(res);
                return res.text();
            }).then(data => {
                this.registEnemy(data);
                this.post_send = false; //POSTリクエスト中のフラグを下げる
            }).catch(e => {
                this.$store.dispatch("alertModal/saveTitle","Error");
                this.$store.dispatch("alertModal/saveMessage",e + "\n有効なポケモン名を入力してください。");
                this.$store.dispatch("alertModal/changeFlagState");
                this.enemy_name = ""; //ポケモン名をリセット
                this.post_send = false; //POSTリクエスト中のフラグを下げる
            });
        },
        /**
         * POSTリクエストの返信として受け取った内容を仮想敵ポケモンとして登録
         * @param {JSON} str
         */
        registEnemy(str) {
            const regist = JSON.parse(str);
            this.enemy_id = regist.id;
            this.enemy_image_id = regist.image_id;
            this.enemy_s_base = regist.s;
        },
        /**
         * 仮想敵ポケモンの素早さを計算
         * @returns {Number} calcResult
         */
        calculateEnemySpeed() {
            let calc_result = Math.floor((this.enemy_s_base * 2 + this.enemy_s_ind + this.enemy_s_eff / 4) * this.enemy_level / 100); //性格補正考慮前の計算
            calc_result = Math.floor((calc_result + 5) * this.getSpeedCharacterNumber(this.enemy_s_cha)); //性格補正を考慮
            return calc_result;
        },
        /**
         * 仮想敵ポケモンの補正適用後の素早さを計算
         * @returns {Number} calcResult
         */
        calculateEnemyFinalSpeed() {
            let calc_result = Math.floor(this.calculateEnemySpeed() * this.enemy_skill * this.returnRankcorrection(this.enemy_rank) * this.enemy_item * this.enemy_paralysis);
            return calc_result;
        },
        /**
         * すばやさに対する性格補正値を返す
         * @returns {Number} cor
         */
        getSpeedCharacterNumber(s_cha) {
            let cor = 1;
            if (s_cha === "上昇補正") {
                cor += 0.1; //上昇補正あり
            }
            else if (s_cha === "下降補正") {
                cor -= 0.1; //下降補正あり
            }
            return cor;
        },
        /**
         * 性格補正に対応した文字色を返す
         * @returns {String} color
         */
        getCharacterColor() {
            let color = ""; //文字色(初期値はサイトでのデフォルトの文字色に従う)
            if (this.enemy_s_cha === "上昇補正") {
                color = "text-danger"; //上昇補正あり(赤)
            }
            else if (this.enemy_s_cha === "下降補正") {
                color = "text-primary"; //下降補正あり(青)
            }
            return color;
        },
        /**
         * 対象ポケモンの画像を取得
         * @returns {String} img_url
         */
        getEnemyPokemonImage() {
            let img_url = "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/home/";
            img_url = img_url.concat(this.enemy_image_id, ".png");
            return img_url;
        },
        /**
         * ポケモン徹底攻略様における対象ポケモンの詳細情報ページのリンクを取得
         * @returns {String} poketetsu_link
         */
        getPokeTetsuLink() {
            let poketetsu_link = "https://yakkun.com/sv/zukan/?national_no=";
            poketetsu_link = poketetsu_link.concat(this.enemy_id);
            return poketetsu_link;
        },
        /**
         * ひらがなをカタカナに変換 (UTF-8: U+3041~U+3096 → U+30A1~U+30F6)
         * @returns {String} String.fromCharCode(chr)
         */
        hiragana2Katakana() {
            this.enemy_name = this.enemy_name.replace(/[\u3041-\u3096]/g, function (match) {
                let chr = match.charCodeAt(0) + 0x60;
                return String.fromCharCode(chr);
            });
        },
        /**
         * 上限値および下限値の範囲外の数値が入力された場合の修正処理
         * @param {String} target_value
         * @param {String} handler
         */
        checkValueRange(target_value, handler) {
            let value = this[target_value]; //比較する数値
            let max_num = 0; //上限値(handlerに応じて値を変化)
            let min_num = 0; //下限値
            switch (handler) {
                case "ind": //個体値
                    max_num = 31;
                    break;
                case "eff": //努力値
                    max_num = 252;
                    break;
                case "level": //レベル
                    max_num = 100;
                    min_num = 1;
                    break;
                case "line": //目標ライン
                    max_num = 500;
                    break;
                case "rank": //ランク補正
                    max_num = 6;
                    min_num = -6;
                    break;
                case "skill": //特性補正
                    max_num = 2;
                    min_num = 0.5;
                    break;
                case "item": //道具補正
                    max_num = 2;
                    min_num = 0.5;
                    break;
                case "paralysis": //麻痺補正
                    max_num = 1;
                    min_num = 0.5;
                    break;
                default:
                    this.$store.dispatch("alertModal/saveTitle","Technical Error");
                    this.$store.dispatch("alertModal/saveMessage","以下の内容と直前の作業内容を管理人に報告してください。\ncheckValueRange() Bug:handlerに正しい値を設定してください。");
                    this.$store.dispatch("alertModal/changeFlagState");
            }
            /* 確認処理 */
            if (value > max_num)
                value = max_num; //上限値に設定
            if (value < min_num)
                value = min_num; //下限値に設定
            this[target_value] = value; //修正結果を反映
        },
        /**
         * ランク補正に応じた倍率を返す
         * @param {Number} rank
         * @returns {Number} cor
         */
        returnRankcorrection(rank) {
            let cor = 2 / 2; //初期化
            if (rank > 0) {
                cor = (2 + rank) / 2;
            }
            else {
                cor = 2 / (2 + Math.abs(rank));
            }
            return cor;
        },
        /**
         * handlerの指示に従って、最速、準速、最遅のいずれかに設定
         * @param {String} handler
         */
        setTemplateSpeed(handler) {
            switch (handler) {
                case "最速":
                    this.enemy_s_ind = 31;
                    this.enemy_s_eff = 252;
                    this.enemy_s_cha = "上昇補正";
                    break;
                case "準速":
                    this.enemy_s_ind = 31;
                    this.enemy_s_eff = 252;
                    this.enemy_s_cha = "補正なし";
                    break;
                case "無振り":
                    this.enemy_s_ind = 31;
                    this.enemy_s_eff = 0;
                    this.enemy_s_cha = "補正なし";
                    break;
                case "最遅":
                    this.enemy_s_ind = 0;
                    this.enemy_s_eff = 0;
                    this.enemy_s_cha = "下降補正";
                    break;
                default:
                    this.$store.dispatch("alertModal/saveTitle","Technical Error");
                    this.$store.dispatch("alertModal/saveMessage","以下の内容と直前の作業内容を管理人に報告してください。\nsetTemplateSpeed() Bug:handlerに正しい値を設定してください。");
                    this.$store.dispatch("alertModal/changeFlagState");
            }
        },
        /**
         * 各種補正リセット
         */
        resetCorrection(){
            this.enemy_s_cha = "補正なし";
            this.enemy_rank=0;
            this.enemy_skill=1;
            this.enemy_item=1;
            this.enemy_paralysis=1;
        },
    },
    computed: {
        /**
         * ポケモンの名前一覧を表示
         * @returns {String[]} this.$store.getters["pokemonList/getPokemonList"]
         */
        getPokemonList() {
            return this.$store.getters["pokemonList/getPokemonList"];
        },
        /**
         * "反映"ボタンについて、ポケモン名の入力状況とPOSTリクエスト状況を伝える
         * @returns {Number} 0 (ポケモン名未入力) or 1 (ポケモン名入力のみ) or 2 (ポケモン名入力&POSTリクエスト中)
         */
        searchRequestFlag() {
            if (this.enemy_name === "") { //ポケモン名未入力
                return 0;
            }
            else { //ポケモン名入力
                if (this.post_send) { //POSTリクエスト中
                    return 2;
                }
                else { //POSTリクエスト中ではない
                    return 1;
                }
            }
        },
        /**
         * 対象ポケモンの全国図鑑番号が登録されているかの確認
         * @returns {boolean} true (登録されている) or false (登録されていない)
         */
        checkEnemyPokemonId() {
            if (this.enemy_id != null) { //登録されている
                return true;
            }
            else { //登録されていない
                return false;
            }
        },
        /**
         * 対象ポケモンの画像IDが登録されているかの確認
         * @returns {boolean} true (登録されている) or false (登録されていない)
         */
        checkEnemyPokemonImageId() {
            if (this.enemy_image_id != null) { //登録されている
                if (this.enemy_image_id == "99999") {//画像IDが "99999" の場合 (画像を用意できていないポケモンへの一時的な処理)
                    return false;
                }
                else {//画像を用意できているポケモン
                    return true;
                }
            }
            else { //登録されていない
                return false;
            }
        },
    },
}
</script>

<style scoped>
.main_card {
    color: white;
    background-color: #707070;
}
.enemy_card {
    color: white;
    background-color: #60c2ff;
}
.form-control:focus {
    border-color: #60c2ff;
    box-shadow: 0 0 0 0.2rem rgba(96, 194, 252, 0.5);
}
.btn-outline-primary {
    color: #60c2ff;
    border-color: #60c2ff;
}
.btn-outline-primary:hover {
    color: white;
    background-color: #60c2ff;
}
.btn-outline-danger {
    color: #ff3d3d;
    border-color: #ff3d3d;
}
.btn-outline-danger:hover {
    color: white;
    background-color: #ff3d3d;
}
.link {
    color: #60c2ff;
}
.border {
    color: white;
    background-color: #60c2ff;
}
.form-select:focus {
    border-color: #60c2ff;
    box-shadow: 0 0 0 0.2rem rgba(96, 194, 252, 0.5);
}
.control_card {
    color: white;
    background-color: #00db5b;
}
.form-check-input:checked {
    background-color: #00db5b;
    border-color: #00db5b;
}
.form-check-input:focus {
    border-color: #00db5b;
    box-shadow: 0 0 0 0.2rem rgba(0, 219, 91, 0.5);
}
.btn-outline-success {
    color: #00db5b;
    border-color: #00db5b;
}
.btn-outline-success:hover {
    color: white;
    background-color: #00db5b;
}
</style>